module.exports = __webpack_public_path__ + "img/Get_AI_driven_opportunities.3dd9c8d9.png";